<template>
	<el-form-item :prop="prop">
		<el-upload :limit="document_limit" :on-exceed="onExceed" :on-error="onError" :on-success="onSuccess"  class="upload-demo upload-alt" :auto-upload="true" :action="upload_api"	multiple :file-list="file_list" accept="application/pdf" :show-file-list="false" :before-upload="testing">
			<div class="" slot="tip">

				<span v-if="item.resourcesLink || item.resourceWord">
					<span v-if="item.isExternal">
						<el-button  class="instructionsBtn" @click="openResource(item.resourceLink)" size="small" type="default">
							<i class="el-icon-info"></i> {{item.resourceWord}}
						</el-button>
					</span>
					<span v-else>
						<el-button v-if="item.resourceWord && !item.resourceLink"  class="instructionsBtn" @click="openResource(item.resourceWord)" size="small" type="default">
							<i class="el-icon-info"></i>
						</el-button>
						<el-button v-if="item.resourceLink"  class="instructionsBtn" @click="openResource(item.resourceLink)" size="small" type="default">
							<i class="el-icon-info"></i> {{item.resourceWord}}
						</el-button>
					</span>
				</span>
				<span v-else :style="{visibility: item.instructionalTxt ? 'visible' : 'hidden'}">
					<el-button size="small" type="default" class="attachment-title instructionsBtn" slot="tip" @click="$emit('show-modal',item)"><i class="el-icon-info"></i></el-button>
				</span>

			</div>
			<el-button class="btnUpload" size="small" type="success"><i class="el-icon-plus"></i>Attach {{item.name}} (pdf)</el-button>
		</el-upload>
		<ul class="file-upload-list">
			<li v-for="(attachment, index) in attachments" :key="`${item.category}-${index}`">
				<div style="display:flex;align-items:center;margin-right:7px;">
					{{ attachment.name }}
				</div>
					<el-button
						type="text"
						icon="el-icon-delete"
						@click="onRemove(attachment)"/>
			</li>
		</ul>
	</el-form-item>
</template>

<script>
import attachment_mixin from '@/js/mixins/attachment-mixin.js';
export default {
	mixins: [attachment_mixin],
	props: ['item'],
	data(){
		return {
			document_limit: 10,
			prop: (this.item.scoped) ? `attachments.${this.item.category}` : this.item.category // Scoping for proper validation
		}
	},
	computed: {
		attachments(){
			return this.$store.state.application.attachments[this.item.category];
		}
	},
	methods: {
		onExceed(){
			this.$notify.error({
				title: 'Limit Reached',
				message: `You are limited to ${this.document_limit} documents for each category.`
			})
		},
		openResource(url){
			window.open(url);
		}
	}
}
</script>
<style lang="scss">
.file-upload-list{
	li{
		display:flex;
	}
}
.cc-attachment .resource-button{
	margin-left:15px !important;

}
.cc-attachment h2{
	display:inline-block;
	margin:0px;
	padding-top:0 !important;
}
.upload-alt .el-button{
	/* float:left; */
}
.upload-alt .el-upload{
	float:left;
	margin-right:7px;
}
.instructionsBtn{
	margin-left:12px;
}

</style>
